var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.373,
    height: 20,
    viewBox: "0 0 16.373 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-98.69 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49065",
    "data-name": "Path 49065",
    d: "M112.57,68H101.183a2.5,2.5,0,0,1-2.493-2.493V50.493A2.5,2.5,0,0,1,101.183,48h7.468a.746.746,0,0,1,.527.218l5.666,5.666a.746.746,0,0,1,.219.528V65.506A2.5,2.5,0,0,1,112.57,68ZM101.183,49.493a1,1,0,0,0-1,1V65.507a1,1,0,0,0,1,1H112.57a1,1,0,0,0,1-1V54.721l-5.229-5.228Z",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49066",
    "data-name": "Path 49066",
    d: "M290.3,55.158h-3.919a2.5,2.5,0,0,1-2.493-2.493V48.746a.746.746,0,0,1,1.493,0v3.919a1,1,0,0,0,1,1H290.3a.746.746,0,1,1,0,1.493Z",
    transform: "translate(-175.986 0)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49067",
    "data-name": "Path 49067",
    d: "M156,261.449a.342.342,0,0,1,.382-.309h1.359a1.383,1.383,0,0,1,1.554,1.515v.033a1.424,1.424,0,0,1-1.62,1.528h-.65v1.422c0,.211-.257.316-.514.316s-.511-.1-.511-.316Zm1.027.586v1.39h.652c.369,0,.593-.21.593-.658v-.073c0-.448-.224-.659-.593-.659Z",
    transform: "translate(-54.459 -202.536)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49068",
    "data-name": "Path 49068",
    d: "M232.873,261.14a1.431,1.431,0,0,1,1.62,1.554V264.4a1.431,1.431,0,0,1-1.62,1.554h-1.166c-.27,0-.448-.145-.448-.309v-4.2c0-.165.178-.309.448-.309Zm-.586.9v3.023h.586c.369,0,.593-.21.593-.658v-1.706c0-.448-.224-.659-.593-.659Z",
    transform: "translate(-125.974 -202.536)",
    fill: "#9c9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49069",
    "data-name": "Path 49069",
    d: "M309.351,261.456c0-.211.224-.316.448-.316h2.285c.217,0,.31.231.31.441,0,.244-.112.454-.31.454h-1.706v1.113h1c.2,0,.309.191.309.4,0,.178-.092.389-.309.389h-1v1.7c0,.211-.257.316-.513.316s-.514-.1-.514-.316Z",
    transform: "translate(-200.179 -202.536)",
    fill: "#9c9baa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.cf0eabe23e5926e273cdf99860bc1b6c.svg";
export { ForwardRef as ReactComponent };